export const ProductListPath = '/products';
export const ProductAddPath = '/products/add';
export const ProductEditPath = {
  path: '/products/:skuId',
  withId: (skuId: string): string => {
    return ProductEditPath.path.replace(':skuId', skuId);
  },
};
export const ProductImportPath = '/products/import';
export const ProductCategoryListPath = '/products/categories';
export const ProductCategoryAddPath = '/products/categories/add';
export const ProductCategoryEditPath = {
  path: '/products/categories/:productCategoryId',
  withId: (id: string): string => {
    return ProductCategoryEditPath.path.replace(':productCategoryId', id);
  },
};
export const ProductCategoryProductListPath = {
  path: '/products/categories/:productCategoryId/products',
  withId: (id: string): string => {
    return ProductCategoryProductListPath.path.replace(':productCategoryId', id);
  },
};
export const ProductListListPath = '/products/lists';
export const ProductListAddPath = '/products/lists/add';
export const ProductListEditPath = {
  path: '/products/lists/:productListId',
  withId: (id: string): string => {
    return ProductListEditPath.path.replace(':productListId', id);
  },
};
export const ProductListProductListPath = {
  path: '/products/lists/:productListId/products',
  withProductListId: (productListId: string): string => {
    return ProductListProductListPath.path.replace(':productListId', productListId);
  },
};
export const ProductListProductAddPath = {
  path: '/products/lists/:productListId/products/add',
  withProductListId: (productListId: string): string => {
    return ProductListProductAddPath.path.replace(':productListId', productListId);
  },
};
export const PriceListPath = '/prices';
export const PriceAddPath = '/prices/add';
export const PriceEditPath = {
  path: '/prices/:priceId',
  withId: (id: string): string => {
    return PriceEditPath.path.replace(':priceId', id);
  },
};
export const PriceListListPath = '/pricing/lists';
export const PriceListAddPath = '/pricing/lists/add';
export const PriceListEditPath = {
  path: '/pricing/lists/:priceListId',
  withId: (id: string): string => {
    return PriceListEditPath.path.replace(':priceListId', id);
  },
};
export const PriceListPriceListPath = {
  path: '/pricing/lists/:priceListId/prices',
  withId: (id: string): string => {
    return PriceListPriceListPath.path.replace(':priceListId', id);
  },
};
export const PriceListPriceAddPath = {
  path: '/pricing/lists/:priceListId/prices/add',
  withId: (id: string): string => {
    return PriceListPriceAddPath.path.replace(':priceListId', id);
  },
};
export const PriceListPriceEditPath = {
  path: '/pricing/lists/:priceListId/prices/:priceId',
  withPriceListIdAndPriceId: (priceListId: string, priceId: string): string => {
    return PriceListPriceEditPath.path
      .replace(':priceListId', priceListId)
      .replace(':priceId', priceId);
  },
};
export const PromotionListPath = '/promotions';
export const PromotionAddPath = '/promotions/add';
export const PromotionEditPath = {
  path: '/promotions/:promotionId',
  withId: (promotionId: string): string => {
    return PromotionEditPath.path.replace(':promotionId', promotionId);
  },
};
